import { ArrowRight2 } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import ROUTES from '@/routes';
import type { ContentCommonProps } from './content-common-props';

export default function ContentNotice({ message }: ContentCommonProps) {
  const { t } = useTranslation();

  const groupId = 'GroupID' in message ? message.GroupID : 0;
  const content = ('GroupInfo' in message ? message.GroupInfo : message.Message.split('|').at(0)) ?? '';

  return (
    <Link
      to={ROUTES.MESSAGES.GROUPS.SETTINGS.ANNOUNCEMENT.$buildPath({ params: { id: groupId } })}
      className='chat-bubble text-left group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary'>
      <span className='whitespace-nowrap'> {`[${t('conversation.group-notice')}]`}</span>
      <p className='line-clamp-3 break-all medium:line-clamp-5 pb-1'>{content}</p>
      <div className='h-px w-full bg-base-200' />

      <div className='flex w-full items-center justify-between pt-1 text-sm'>
        <span> {t('common.view-all')}</span> <ArrowRight2 className='size-5' />
      </div>
    </Link>
  );
}
